import { styled } from "@mui/material";

interface ComponentProps {
    handleUpdate: () => void;
    handleDelete: () => void;
}

const QualificationOptions: React.FC<ComponentProps> = ({ handleDelete, handleUpdate}) => {
    return (
        <>
            <StyledCardText onClick={handleUpdate}>Update</StyledCardText>
            <StyledCardText onClick={handleDelete}>Delete</StyledCardText>
        </>
    )
}

export default QualificationOptions;

// const StyledCard = styled('div')`
//   width: 12rem;
//   height: 6rem;
//   border: 0.1rem solid #E1E1E1;
//   background-color: #ffffff;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   border-radius: 0.3rem;
  
// `

const StyledCardText = styled('button')`
    cursor: pointer;
    padding-inline-start: 1.2rem;
    padding-block: 0.6rem;
    font-size: 1rem;
    color: #232323;
    border: none;
    background-color: transparent;
    text-align: left;
    &:hover {
        background-color: #f1f1f1;
    }
    
`